export default function Logo({ variant = "dark", className = "" }) {
    const textColor = variant === "dark" ? "text-white" : "text-zinc-950";
    return (
        <div
            data-testid="truopay-logo"
            className={`inline-flex items-center gap-2 select-none ${className}`}
        >
            <span
                aria-hidden
                className="relative inline-flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-emerald-400 via-emerald-600 to-[#064E3B] glow-emerald"
            >
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                    <path
                        d="M3 6.5C3 5.67 3.67 5 4.5 5h15c.83 0 1.5.67 1.5 1.5S20.33 8 19.5 8H14v10.5c0 .83-.67 1.5-1.5 1.5S11 19.33 11 18.5V8H4.5C3.67 8 3 7.33 3 6.5Z"
                        fill="#FFFFFF"
                    />
                    <circle cx="18.5" cy="17.5" r="2.5" fill="#D4AF37" />
                </svg>
            </span>
            <span className={`font-heading text-xl font-extrabold tracking-tight ${textColor}`}>
                Truo<span className="text-emerald-400">Pay</span>
            </span>
        </div>
    );
}
